import './style/Login.css';
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import { supabase } from '../supabaseClient';

const Login = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [wrongCredentials, setWrongCredentials] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);
    const [passwordTouched, setPasswordTouched] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleEmailChange = (e) => {
        const val = e.target.value;
        setEmail(val);
        if (emailTouched) setEmailError(val.length === 0 ? 'Required' : '');
    };

    const handlePasswordChange = (e) => {
        const val = e.target.value;
        setPassword(val);
        if (passwordTouched) setPasswordError(val.length === 0 ? 'Required' : '');
    };

    const handleEmailBlur = () => {
        setEmailTouched(true);
        setEmailError(email.length === 0 ? 'Required' : '');
    };

    const handlePasswordBlur = () => {
        setPasswordTouched(true);
        setPasswordError(password.length === 0 ? 'Required' : '');
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setEmailTouched(true);
        setPasswordTouched(true);
        const emErr = email.length === 0 ? 'Required' : '';
        const pwErr = password.length === 0 ? 'Required' : '';
        setEmailError(emErr);
        setPasswordError(pwErr);
        if (emErr || pwErr) return;
        setLoading(true);
        setWrongCredentials(false);
        try {
            const { data, error } = await supabase.auth.signInWithPassword({ email, password });
            if (error) {
                setWrongCredentials(true);
                setErrorMessage(error.message === 'Email not confirmed' ? 'Please verify your email before logging in.' : 'Invalid email or password.');
                return;
            }
            const profileRes = await fetch(`${process.env.REACT_APP_API_BASE}/me`, {
                headers: { Authorization: `Bearer ${data.session.access_token}` },
            });
            const profile = await profileRes.json();
            if (profile.success) {
                props.setUser(profile.user);
                navigate('/arena');
            } else {
                setWrongCredentials(true);
                setErrorMessage('Account profile not found.');
            }
        } 
        catch (error) {
            console.error('Error:', error);
            setWrongCredentials(true);
            setErrorMessage('Something went wrong. Please try again.');
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className='login-container'>
            <PublicNav user={props.user} />
            <form onSubmit={onSubmit}>
                <div className='panel-header'>
                    <h3>Welcome Back</h3>
                    <p>Log in to continue practicing</p>
                </div>
                <div className='credentials-section'>
                    <div className={`input-group${emailError && emailTouched ? ' input-error' : ''}`}>
                        <input className='email-input' type='text' name='email' id='login-email' value={email} onChange={handleEmailChange} onBlur={handleEmailBlur} placeholder=' '/>
                        <label htmlFor='login-email'>Email</label>
                        {emailError && emailTouched && <span className='field-error'>{emailError}</span>}
                    </div>
                    <div className={`input-group${passwordError && passwordTouched ? ' input-error' : ''}`}>
                        <input className='password-input' type='password' name='password' id='login-password' value={password} onChange={handlePasswordChange} onBlur={handlePasswordBlur} placeholder=' '/>
                        <label htmlFor='login-password'>Password</label>
                        {passwordError && passwordTouched && <span className='field-error'>{passwordError}</span>}
                    </div>
                    {wrongCredentials && <div className='error'>{errorMessage}</div>}
                </div>
                <div className='actions-section'>
                    <button type="submit" disabled={loading}>
                        {loading ? <div className='login-spinner' /> : 'Log In'}
                    </button>
                    <div className='action-links'>
                        <Link className='forgot-password' to="/forgot-password">Forgot Password?</Link>
                    </div>
                    <span className='signup-link'>Don't have an account? <Link to="/signup">Sign up</Link></span>
                </div>
            </form>
        </div>
    );
};

export default Login;